export const normalLanguageArr = [
  {
    label: 'English',
    value: 'en',
  },
  {
    label: 'ภาษาไทย',
    value: 'th',
  },
  {
    label: 'Indonesia',
    value: 'id',
  },
  {
    label: 'Deutsch',
    value: 'de',
  },
  {
    label: 'Français',
    value: 'fr',
  },
  {
    label: 'Português',
    value: 'pt',
  },
  {
    label: 'Русский',
    value: 'ru',
  },
  {
    label: 'Español',
    value: 'es',
  },
];

export const htmLanguageArr = [
  {
    label: '中文（繁体）',
    value: 'zh',
  },
];

export const languageArr = [...htmLanguageArr, ...normalLanguageArr];
